import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { OnChange, OnClick } from "../../../library-js/dom-tools/EventListeners";
import { Loader } from "../../../library-js/dom-tools/Loader";
import { CSV, CSVIndex } from "../../../library/ts/vanilla/text/CSV";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { PrettyJSON } from "../../../library-js/text/PrettyJSON";
import { ScrapeRequest } from "../../../dev-tools/scraper/src/main/ScrapeRequest";
import { RandomUIDGenerator } from "../../../library-js/random/RandomUIDGenerator";
import { sleep } from "../../../library-js/animation/sleep";

export class LocalIO
{ 
  static loadPath = "../_load.php?path=";
  static savePath = "../_save.php?path=";
  static getPath  = "../_get.php?path=";
  static existsPath  = "../_exists.php?path=";
  
  static async exists( path:string ):Promise<boolean>
  {
    let result = await Loader.loadText( this.existsPath + path );
    return result === "true";
  }

  static async loadCSV( path:string ):Promise<CSV>
  {
    let text = await this.loadText( path );
    let csv = CSV.fromText( text );
    csv.filePath = path;
    return csv;
  }

  static createLoadingPath( path:string )
  {
    return this.loadPath + path;
  }

  static async loadDoc( path:string ):Promise<Document>
  {
    let text = await this.loadText( path );
    return HTMLEditor.stringToDocument( text );
  }

  static async loadJSON<T>( path:string):Promise<T>
  {
    let text = await this.loadText( path );
    return JSON.parse( text ) as T;
  }

  static async loadText( path:string ):Promise<string>
  {
    return await Loader.loadText( this.loadPath + path );
  } 

  static async getHtmlPage( path:string ):Promise<string>
  {
    let scraperPath = "C:/rokojori/projects/web-sites/source/dev-tools/scraper/data/";
    let requestsPath = scraperPath + "requests/";
    let donesPath     = scraperPath + "done/";

    let url = "http://localhost:1712/load"; 
    let input = { path: path };
    input = { path: "https://www.google.de/" };

    let scrapeRequest = new ScrapeRequest();
    scrapeRequest.url = path;

    let id = RandomUIDGenerator.createUID();
    let fileName = id + ".json";
    let requestPath = requestsPath + fileName;
    let donePath    = donesPath + fileName;

    await this.saveJSON( requestPath, scrapeRequest );

    await sleep( 3000 );

    let exists = await this.exists( donePath );
    let maxTries = 100;
    let tries = 0;

    while ( ! exists && tries < maxTries )
    {
      await sleep( 200 );
      exists = await this.exists( donePath );

      tries ++;
    }

    if ( ! exists )
    {
      return null;
    }

    let resultSR = await this.loadJSON<ScrapeRequest>( donePath );

    return resultSR.outputData;
    
  } 

  static async saveCSV( path:string, csv:CSV ):Promise<void>
  {
    await this.saveText( path, csv.serialize() );
  }

  static async saveJSON( path:string, json:any ):Promise<void>
  {
    await this.saveText( path, PrettyJSON.stringify( json ) );
  }

  static async saveText( path:string, text:string ):Promise<void>
  {
    let requestURL = LocalIO.savePath + path;
    
    let promise = new Promise<void>(
      ( resolve, reject )=>
      {
        var xhttp = new XMLHttpRequest();
        xhttp.open( "POST", requestURL, true );
        xhttp.setRequestHeader( "Content-Type", "application/json");
    
        let sendingData = text;
    
        xhttp.onerror = ()=>
        {
          console.warn( "ERROR REQUESTING: ", requestURL, text );
          reject();          
        }
    
        xhttp.onload = ()=>
        {                  
          console.log( xhttp.response );
          resolve();          
        }
        
        xhttp.send( sendingData );
      }
    );

    return promise;  
  }

}